import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import ArrowIcon from 'components/ArrowIcon';

import Table from './Table';
import SubItem from './SubItem';
import { Head, Content, Text } from './styles';

const Item = ({ id, name, tables, description, subItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = useCallback(() => setIsOpen(($) => !$), []);

  return (
    <div>
      <Head type="button" onClick={handleClick} $id={id}>
        {name}
        <ArrowIcon isOpen={isOpen} />
      </Head>
      <Content $isOpen={isOpen}>
        {description && <Text>{description}</Text>}
        {tables.length > 0 &&
          tables.map(({ type, name: tableName, head, body }) => (
            <Table key={tableName} type={type} name={tableName} head={head}>
              {body}
            </Table>
          ))}
        {subItems.length > 0 &&
          subItems.map((subItem, index, arr) => (
            <SubItem key={subItem.name} lastItem={index === arr.length - 1} isOpenParent={isOpen} {...subItem} />
          ))}
      </Content>
    </div>
  );
};

Item.defaultProps = {
  description: null,
  tables: [],
  subItems: [],
};
const itemTypes = PropTypes.shape({
  type: PropTypes.oneOf(['dataSources', 'dataObject']).isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  head: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  body: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired).isRequired
  ).isRequired,
});
Item.propTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  tables: PropTypes.arrayOf(itemTypes.isRequired),
  subItems: PropTypes.arrayOf(itemTypes.isRequired),
}).isRequired;

export default Item;
